export default __webpack_public_path__ + "static/media/answerer.3d7e7558.mp3";